import { writable } from 'svelte/store';

export const eventConfig = writable({});
